import $http from "../../axios";
import {
  Notification,
  MessageBox
} from 'element-ui';

//Obtener las bodegas
export async function fetchBranchOfficeWarehouses({commit, state}, brancheoffice) {
    await $http.get(`/api/bodegas-sedes?branchoffice_id=${brancheoffice}`)
        .then((response) => {
        commit('setBranchofficeWarehouses', response.data.data)
        })
        .catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

//Obtener las sedes
export async function fetchBranchOffices({commit, state}) {
    await $http.get('/api/sedes')
      .then((response) => {
        commit('setBranchOffices', response.data)
      })
      .catch((error) => {
        Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 2000,
          customClass: 'notification-box',
        });
        commit('BranchOfficeError', error.message)
      })
  }

  //Obtener los terceros
export async function fetchContacts({
    commit,
    state
}, requestParameters = {
    params: state.paramsquery
}) {

    await $http.get('/api/terceros', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data.data)

        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })
}

//consulta kardex
export async function getKardex({commit,state,dispatch}) {
    state.loading.kardex = true
    var data = {
        params: state.params,
        product: state.product
    }
    await $http.get('/api/kardex', data)
        .then(async (response) => {
            commit('setKardex', response.data.data)
            await dispatch('validateExistencesByDocumentProductId')
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
    state.loading.kardex = false
}

export async function searchProducts ({
    state,
    commit
}) {

    let requestParameters = {
        params: state.paramsProducts
    }
    await $http.get('/api/lista-productos', requestParameters).then((response) => {
        commit('setStateProducts', response.data.data.data)
    }

    )
}

/**
 * Validar existencia.
 */
export async function validateExistencesByDocumentProductId({commit, state}) {
        let params = {
            branchoffice_warehouse_id: state.params.bodega_salida,
            product_id: state.params.product
        };

        await $http.get('/api/consulta-existencias', {params})
            .then(async response => {
                commit('setInventory', response.data.data)
            }).catch((error) => {
                commit('setInventory',null)
                console.error(error);
            });
}


export async function fixvalues ({ commit }, params) {
    let requestParameters = { params:params }
    await $http.get(`/api/reconstructor`, requestParameters)
      .then((response) => {
      })
      .catch((error) => {
        Notification.error({
          title: 'Error!',
          message: error.message,
          type: 'error',
          duration: 2000,
          customClass: 'notification-box',
        });
    })
  }

export async function downloadDocument({state}, documentToPdf) {
    console.log(documentToPdf)
  state.loading.download_pdf = true
    let name ='';
    if (documentToPdf.name_pdf){
         name = documentToPdf.name_pdf.replace(".", "")+'.pdf'
    }else{
        name = documentToPdf.vouchertype.name_voucher_type + ' No. ' + documentToPdf.consecutive + '.pdf'
    }

  let url = ''
  let document_id = documentToPdf.document_id ? documentToPdf.document_id : documentToPdf.id

    if (documentToPdf.vouchertype && documentToPdf.vouchertype.code_voucher_type === '100'){
        if ([4, 35].includes(documentToPdf.operationType_id)){
            url ='/api/traslado/descargar-pdf/' + documentToPdf.id
        }
        else {
            url = '/api/traslado/descargar-pdf/' + documentToPdf.thread
        }

    }else{
        if ([4, 35].includes(documentToPdf.operationtype_id)){
            url ='/api/traslado/descargar-pdf/' + documentToPdf.document_id
        }else if ([3, 36].includes(documentToPdf.operationtype_id)){
            url = '/api/traslado/descargar-pdf/' + documentToPdf.thread
        }else{
            url = '/api/documentos/descargar-pdf/' + document_id
        }

    }

  await $http({
    url: url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 3000,
      customClass: 'notification-box',
    });

  })
  state.loading.download_pdf = false
}


export async function fetchProducts ({ commit, state }, params = {}) {
    await $http
        .get("/api/lista-productos-select", {
            params: {
                ...params,
                manage_inventory: true
            }
        })
        .then(response => {
            commit("setProducts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function docLabelPrintingCsv({ commit }, params = {}) {
  try {
    const response = await $http.get("/api/doc-label-printing", {
      params: {
        ...params,
        branchoffice_warehouse_id: localStorage.selected_branchoffice_warehouse
      },
      responseType: "blob"
    });

    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });

    if (window.showSaveFilePicker) {
      // Chrome / Edge: abre el diálogo "Guardar como" siempre
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: "Archivo Etiquetas.csv",
          types: [
            {
              description: "Archivo CSV",
              accept: { "text/csv": [".csv"] }
            }
          ]
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
      } catch (err) {
        // Si el usuario cancela el diálogo, no lanzar error
        if (err.name !== "AbortError") {
          throw err;
        }
      }
    } else {
      // Fallback para Firefox / Safari (no soportan showSaveFilePicker)
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Archivo Etiquetas.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    Notification.error({
      title: "Error!",
      message: error.message,
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  }
}


// WEBPACK FOOTER //
// ./src/modules/kardex/actions.js